import { Badge, type BadgeProps } from '@/components/ui/badge';
import type { CampaignDto } from '@/generated/korza-api-client/types.gen';
import { useI18nContext } from '@/i18n/i18n-react';

const VARIANT: Record<CampaignDto['status'], BadgeProps['variant']> = {
  draft: 'outline',
  scheduled: 'secondary',
  sent: 'default',
};

/** Rascunho / Agendada / Enviada (PUSH-01 AC 2). */
export function CampaignStatusBadge({
  status,
  className,
}: {
  status: CampaignDto['status'];
  className?: string;
}) {
  const { LL } = useI18nContext();
  const label: Record<CampaignDto['status'], string> = {
    draft: LL.campaigns.status.draft(),
    scheduled: LL.campaigns.status.scheduled(),
    sent: LL.campaigns.status.sent(),
  };
  return (
    <Badge variant={VARIANT[status]} className={className} data-status={status}>
      {label[status]}
    </Badge>
  );
}
